import { StreamingVideoPlayer } from '@components/video/StreamingVideoPlayer'
import React, { useRef, useState, useEffect } from 'react'
import ReelPlayIcon from '../../../public/reel-play-icon.svg'

const ReelVideo = ({
  src,
  playbackId,
  title,
  wrapperClassName,
  videoClassName,
  playsInline = true,
}: {
  src?: string
  playbackId?: string
  title: string
  wrapperClassName?: string
  videoClassName?: string
  playsInline?: boolean
}) => {
  const childRefs = useRef(null)

  const [isPlaying, setIsPlaying] = useState(false)

  const pauseVideo = ({ target }) => {
    if (!childRefs.current?.contains(target)) {
      if (!childRefs.current?.childNodes[0].paused) {
        childRefs.current?.childNodes[0].pause()

        setIsPlaying(false)
      }
    }
  }

  useEffect(() => {
    window?.addEventListener('click', pauseVideo)

    return () => {
      window?.removeEventListener('click', pauseVideo)
    }
  }, [])

  const playReelVideo = () => {
    childRefs.current?.childNodes[0].play()
    setIsPlaying(true)
  }

  const pauseReelVideo = () => {
    childRefs.current?.childNodes[0].pause()
    setIsPlaying(false)
  }

  return (
    <div
      className={`relative h-full ${wrapperClassName}`}
      role="presentation"
      ref={childRefs}
    >
      {src ? (
        <video
          className={`h-full w-full ${videoClassName}`}
          src={`${src}#t=0.001`}
          title={title}
          preload="metadata"
          onClick={() =>
            childRefs.current?.childNodes[0].paused
              ? playReelVideo()
              : pauseReelVideo()
          }
          loop
          playsInline={playsInline}
        />
      ) : playbackId ? (
        <StreamingVideoPlayer
          classname={`h-full w-full ${videoClassName}`}
          playbackId={playbackId}
          title={title}
          onClick={() =>
            childRefs.current?.childNodes[0].paused
              ? playReelVideo()
              : pauseReelVideo()
          }
          playsInline={playsInline}
        />
      ) : null}
      <img
        className={`absolute inset-0 mr-auto m-auto ${isPlaying && '!hidden'}`}
        src={ReelPlayIcon}
        alt="Reel Play Button"
        onClick={() => {
          childRefs.current?.childNodes[0].paused
            ? playReelVideo()
            : pauseReelVideo()
        }}
        width="55"
        height="55"
        role="button"
      />
    </div>
  )
}

export default ReelVideo
